const getLocationString = (locations: Array<{id: number; name: string}>) => {
  let locationMap = '';

  const locationsInfo = locations?.filter(location => location?.name);

  locationsInfo?.forEach((location, index) => {
    if (index > 0) {
      locationMap = `${locationMap}/${location?.name}`;
    } else {
      locationMap = location?.name;
    }
  });

  return locationMap;
};

export {getLocationString};
